export interface WithAbortRequestConfig {
	signal?: AbortSignal
}
// eslint-disable-next-line no-restricted-syntax
export enum HTTPMethod {
	GET = 'GET',
	POST = 'POST',
	PUT = 'PUT',
	DELETE = 'DELETE',
	PATCH = 'PATCH',
}
